
export const getPermalink = (blueprintId: string) => {
  return `https://fprints.xyz/blueprint/${blueprintId}`;
};
